import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/auditTime';
import { DOMService } from './dom.service';
import { FRAME_DURATION, isDocumentAvailable } from '../util';
/**
 * @hidden
 */
export var THRESHOLD_DIFF = 1;
/**
 * @hidden
 */
var ScrollableService = (function () {
    function ScrollableService(_dom, _zone) {
        this._dom = _dom;
        this._zone = _zone;
    }
    ScrollableService.prototype.forElement = function (element) {
        this.unsubscribe();
        this.element = element;
        return this;
    };
    ScrollableService.prototype.subscribe = function (callback) {
        var _this = this;
        if (!callback || !isDocumentAvailable() || !this.element) {
            return;
        }
        var nativeElement = this._dom.nativeElement(this.element);
        var parents = this._dom.scrollableParents(this.element);
        this._zone.runOutsideAngular(function () {
            var observables = parents.map(function (p) { return Observable.fromEvent(p, "scroll").auditTime(FRAME_DURATION); });
            var subscriber = function (e) {
                callback(_this.isVisible(nativeElement, e.target));
            };
            _this.subscription = Observable.merge.apply(Observable, observables).subscribe(subscriber);
        });
    };
    ScrollableService.prototype.unsubscribe = function () {
        if (!this.subscription) {
            return;
        }
        this.subscription.unsubscribe();
    };
    ScrollableService.prototype.isVisible = function (elem, container) {
        var elemRect = this._dom.boundingOffset(elem);
        var containerRect = this._dom.boundingOffset(container);
        if ((containerRect.top - elemRect.bottom) > THRESHOLD_DIFF) {
            return false;
        }
        if ((containerRect.bottom - elemRect.bottom) < -THRESHOLD_DIFF) {
            return false;
        }
        if ((containerRect.right - elemRect.right) < -THRESHOLD_DIFF) {
            return false;
        }
        if ((containerRect.left - elemRect.left) > THRESHOLD_DIFF) {
            return false;
        }
        return true;
    };
    return ScrollableService;
}());
export { ScrollableService };
ScrollableService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ScrollableService.ctorParameters = function () { return [
    { type: DOMService, },
    { type: NgZone, },
]; };



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-dropdowns/~/@progress/kendo-angular-popup/dist/es/services/scrollable.service.js
// module id = ../../../../@progress/kendo-angular-dropdowns/node_modules/@progress/kendo-angular-popup/dist/es/services/scrollable.service.js
// module chunks = 3